module.exports = __webpack_public_path__ + "img/one_2.6a7a20f8.png";